export default "__VITE_ASSET__D6glUA8c__"